export const usersList = 'usersList';
export const availableUserOptions = 'availableOptions';
export const usernameAvailable = 'username';
